module.exports = __webpack_public_path__ + "img/logo-big.0d1580761ed899fd71f6c3066d06b626.svg";